
import React, { useState } from 'react';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface ChatMessage {
  id: string;
  sender: {
    name: string;
    avatarUrl: string;
  };
  content: string;
  timestamp: Date;
}

const LiveSessionChat: React.FC = () => {
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState<ChatMessage[]>([
    {
      id: '1',
      sender: {
        name: 'Alex Turner',
        avatarUrl: 'https://i.pravatar.cc/150?img=32'
      },
      content: 'Let\'s try recording the chorus again with a bit more energy.',
      timestamp: new Date(Date.now() - 1000 * 60 * 5) // 5 minutes ago
    },
    {
      id: '2',
      sender: {
        name: 'Sam Wilson',
        avatarUrl: 'https://i.pravatar.cc/150?img=53'
      },
      content: 'I think we should add a bit more reverb to the vocal track.',
      timestamp: new Date(Date.now() - 1000 * 60 * 3) // 3 minutes ago
    },
    {
      id: '3',
      sender: {
        name: 'Taylor Swift',
        avatarUrl: 'https://i.pravatar.cc/150?img=45'
      },
      content: 'The levels look good now. Ready for the next take!',
      timestamp: new Date(Date.now() - 1000 * 60 * 1) // 1 minute ago
    }
  ]);
  
  const handleSendMessage = () => {
    if (message.trim() === '') return;
    
    const newMessage: ChatMessage = {
      id: Date.now().toString(),
      sender: {
        name: 'You (Jamie Collins)',
        avatarUrl: 'https://i.pravatar.cc/150?img=68'
      },
      content: message,
      timestamp: new Date()
    };
    
    setMessages([...messages, newMessage]);
    setMessage('');
  };
  
  const formatTime = (date: Date) => {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };
  
  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 overflow-y-auto p-4 space-y-4">
        {messages.map((msg) => (
          <div key={msg.id} className="flex items-start gap-2">
            <Avatar className="h-8 w-8">
              <AvatarImage src={msg.sender.avatarUrl} />
              <AvatarFallback>
                {msg.sender.name.split(' ').map(n => n[0]).join('')}
              </AvatarFallback>
            </Avatar>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-white">{msg.sender.name}</span>
                <span className="text-xs text-white/50">{formatTime(msg.timestamp)}</span>
              </div>
              <p className="text-sm text-white/80 mt-0.5">{msg.content}</p>
            </div>
          </div>
        ))}
      </div>
      
      <div className="p-4 border-t border-white/10">
        <div className="flex gap-2">
          <Input
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type a message..."
            className="bg-white/10 border-white/20 text-white placeholder:text-white/50"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSendMessage();
              }
            }}
          />
          <Button 
            onClick={handleSendMessage}
            variant="glass"
          >
            Send
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LiveSessionChat;
